export default __webpack_public_path__ + "static/media/0xc10358f062663448a3489fc258139944534592ac.b1c6580f.png";